import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useScreen(breakpoint = 768) {
    const isMobile = ref(window.innerWidth <= breakpoint);

    const updateScreen = () => {
        isMobile.value = window.innerWidth <= breakpoint;
    };

    onMounted(() => {
        window.addEventListener('resize', updateScreen);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', updateScreen);
    });

    return {
        isMobile,
    };
}